<template>
  <div>
    <br />
    <b-container>
      <div class="alert alert-danger">
        <p>
          Usted no se encuentra incorporado en el Registro Electoral. Para
          ingresar una solicitud de incorporación presione el botón “Solicitud
          de incorporación” para que se revise su caso con los organismos
          pertinentes.
        </p>
        <p>Considere que:</p>
        <ul style="list-style-type: circle">
          <li style="display: list-item">
            Si es chileno nacido en el extranjero, se consultará a la Policía de
            Investigaciones (PDI) sobre el cumplimiento del requisito de
            avecindamiento de 1 año en Chile.
          </li>
          <li style="display: list-item">
            Si es extranjero, se consultará al Servicio de Migraciones para
            verificar el cumplimiento del requisito de avecindamiento de 5 años
            en Chile.
          </li>
          <li style="display: list-item">
            Si se cumplen los requisitos establecidos será incorporado con el
            domicilio electoral indicado en el siguiente formulario. En el caso
            de extranjeros, solo podrá indicar un domicilio dentro del
            territorio nacional.
          </li>
        </ul>
        <br />

        <p class="text-center">
          <b-button @click="ir()" variant="outline-primary">
            Solicitud de Incorporación
          </b-button>
        </p>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "Redirect",
  data: function () {
    return {};
  },
  methods: {
    async ir() {
      window.location.href = "https://incorporaciones.servel.cl/";
    },
  },
  mounted() {},
};
</script>
